var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85304 0.906154L3.6986 0.87046M3.20888 8.75005L6.08147 8.79764M3.20888 8.75005L3.19799 9.40718M3.20888 8.75005L3.21976 8.09292M6.08147 8.79764L6.07058 9.45477M6.08147 8.79764L6.09236 8.14052M3.23065 7.43579L6.10324 7.48339M3.23065 7.43579L3.21976 8.09292M3.23065 7.43579L3.24154 6.77867M6.10324 7.48339L6.09236 8.14052M6.10324 7.48339L6.11413 6.82626M6.07058 9.45477L6.05969 10.1119L3.1871 10.0643L3.19799 9.40718M6.07058 9.45477L3.19799 9.40718M6.09236 8.14052L3.21976 8.09292M6.11413 6.82626L6.12502 6.16913L3.25243 6.12154L3.24154 6.77867M6.11413 6.82626L3.24154 6.77867M8.20325 10.8047L8.31212 4.23344C8.32414 3.5076 7.69084 2.90853 6.8976 2.89539L2.58871 2.824C1.79547 2.81086 1.14267 3.38862 1.13064 4.11446L1.02177 10.6857C1.00975 11.4116 1.64305 12.0107 2.4363 12.0238L6.74518 12.0952C7.53842 12.1083 8.19122 11.5306 8.20325 10.8047Z",
    stroke: "#59B974",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/BatteryIcon.9cc1591b5dd326612ffeed324a411f42.svg";
export { ForwardRef as ReactComponent };